/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import {
  CircularProgress,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
} from "@mui/material";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { useNavigate } from "react-router-dom";
import { deleteAccount } from "api";

function Cover() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [selectedCode, setSelectedCode] = useState("+91");
  const [mobile, setMobile] = useState("");
  const [userType, setUserType] = useState("employee");

  const countryCodes = [
    { code: "+91", label: "🇮🇳" },
    { code: "+1", label: "🇺🇸" },
    { code: "+44", label: "🇬🇧" },
    { code: "+61", label: "🇦🇺" },
    // Add more as needed
  ];

  const deleteAccountApi = () => {
    var params = {
      phone: mobile,
      code: selectedCode,
      type: userType,
    };

    setIsLoading(true);
    deleteAccount({
      params: params,
    })
      .then((responseJson) => {
        setIsLoading(false);

        if (responseJson) {
          navigate("/profile/verify-otp", {
            state: {
              mobile: mobile,
              code: selectedCode,
              type: userType,
            },
          });
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const handleContinue = () => {
    if (mobile) {
      setIsSubmitted(false);
      deleteAccountApi();
    } else {
      setIsSubmitted(true);
    }
  };

  const handleUserTypeChange = (event) => {
    setUserType(event.target.value);
  };

  return (
    <BasicLayout bgColor="info" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          // borderRadius="lg"
          coloredShadow="success"
          // mx={2}
          // mt={-3}
          p={3}
          mb={1}
          textAlign="center"
          sx={{
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
          }}
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Delete Account
          </MDTypography>
          {/* <MDTypography display="block" variant="button" color="white" my={1}>
            You will receive an e-mail.
          </MDTypography> */}
        </MDBox>
        <MDBox pt={2} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleContinue(); // same as your onClick
            }}
          >
            <MDBox pb={3} px={0}>
              <FormControl component="fieldset" display="flex">
                <RadioGroup row name="user-type" value={userType} onChange={handleUserTypeChange}>
                  <FormControlLabel
                    value="employee"
                    control={<Radio color="primary" />}
                    label="Employee"
                    sx={{ mr: 3 }}
                  />
                  <FormControlLabel
                    value="employer"
                    control={<Radio color="primary" />}
                    label="Employer"
                  />
                </RadioGroup>
              </FormControl>
            </MDBox>

            <MDBox mb={2} display="flex" gap={1}>
              <MDBox>
                <MDInput
                  disabled
                  select
                  label="Code"
                  value={selectedCode}
                  onChange={(e) => setSelectedCode(e.target.value)}
                  sx={{ minWidth: 80 }}
                  InputProps={{ sx: { height: "44px" } }}
                >
                  {countryCodes.map((country) => (
                    <MenuItem key={country.code} value={country.code}>
                      {country.label} {country.code}
                    </MenuItem>
                  ))}
                </MDInput>
              </MDBox>
              <MDInput
                type="mobile"
                label={
                  <>
                    Mobile Number
                    <span style={{ color: "red" }}>*</span>
                  </>
                }
                fullWidth
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                helperText={isSubmitted && !mobile ? "Mobile number is required" : ""}
                FormHelperTextProps={{
                  sx: {
                    color: "red",
                    marginLeft: "0",
                  },
                }}
              />
            </MDBox>
            <MDBox mt={6} mb={1}>
              <MDButton
                type="submit"
                variant="gradient"
                color="info"
                fullWidth
                // onClick={handleContinue}
                disabled={isLoading}
              >
                {isLoading ? <CircularProgress size={24} color="light" /> : "Continue"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Cover;
